<template>
    <v-dialog v-model="dialog" width="50%" persistent>
      <v-card v-if="!loading">
        <v-card-title class="primary white--text">Mão de Obra para {{line.Descricao}}</v-card-title>
  
        <v-tabs v-model="tab" background-color="warning" dark fixed-tabs>
          <v-tab>MO Interna</v-tab>
          <v-tab>MO Externa</v-tab>
        </v-tabs>
  
        <v-tabs-items v-model="tab">
          <!-- Tab MO Interna -->
          <v-tab-item>
            <v-card-text>
              <v-row v-for="(item, index) in internos_a_mostrar" :key="index" class="mt-4">
                <v-col cols="12" md="10">
                  <v-autocomplete
                    label="Funcionário"
                    :items="all_workers"
                    disabled
                    dense outlined
                    item-value="Codigo"
                    :item-text="item => item.Codigo + ' - ' + item.Nome"
                    v-model="item.funcionario"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    label="Horas"
                    dense outlined
                    v-model="item.hours"
                    :rules="[
                      v => v === '' || parseFloat(v) <= item.hn || `Horas não pode ser superior a ${item.hn}`
                    ]"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>
  
          <!-- Tab MO Externa -->
          <v-tab-item>
            <v-card-text>
              <v-row v-for="(item, index) in externos_a_mostrar" :key="index+1000" class="mt-4">
                <v-col cols="12" md="10">
                  <v-autocomplete
                    :items="all_external_workers"
                    v-model="item.funcionario"
                    item-value="Numero"
                    :item-text="item=>item.Numero + ' - ' + item.Nome"
                    label="Funcionário"
                    dense outlined
                    disabled
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    label="Horas"
                    dense outlined
                    v-model="item.hours"
                    :rules="[
                      v => v === '' || parseFloat(v) <= item.hn || `Horas não pode ser superior a ${item.hn}`
                    ]"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
  
        <v-card-actions>
            <v-row>
                <v-col cols="12" align="center">
                    <v-btn class="success" rounded @click="save">Gravar</v-btn>
                    <v-btn class="error" rounded @click="$emit('close')">Fechar</v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
<script>
export default{
    name: "MaoObraDialog",
    props:{
        unit: Object,
        total_lines: Number,
        external_workers:{
            typeof: Array,
            default: []
        },
        workers: {
            typeof: Array,
            default: []
        },
        all_workers:{
            typeof: Array,
            default: []
        },
        all_external_workers:{
          typeof: Array,
          default: []
        },
        line:{
            typeof: Object,
            default: null
        },
        divideAllHours:{
          typeof: Boolean,
          default: false
        }
    },
    data() {
        return {
            dialog: true,
            loading: true,
            tab: 0, // Controla as tabs
            internos_a_mostrar: [],
            externos_a_mostrar: []
        };
    },
    mounted(){
        this.workers.forEach(worker => {
          if(worker.classe_id == this.line.classe_id){
            let aux = {...worker}
            aux.hours = null

            if(this.divideAllHours){
              aux.hours = (aux.hn + aux.hext) / this.total_lines;
            }

            this.internos_a_mostrar.push(aux)
          }
        });

        this.external_workers.forEach(worker => {
          if(worker.classe_id == this.line.classe_id){
            let aux = {...worker}
            aux.hours = null

            if(this.divideAllHours){
              aux.hours = (aux.hn + aux.hext) / this.total_lines;
            }
            this.externos_a_mostrar.push(aux)
          }
        })

        this.line.linhas_mo_internal.forEach(linha => {
          this.internos_a_mostrar.forEach(worker => {
              if(linha.funcionario == worker.funcionario)
                if(!this.divideAllHours)
                  worker.hours = linha.hours

                worker.hours = worker.hours == null ? null : parseFloat(worker.hours)
          });
        });

        this.line.linhas_mo_external.forEach(linha => {
            this.externos_a_mostrar.forEach(worker => {
                if(linha.funcionario == worker.funcionario)
                  if(!this.divideAllHours)
                    worker.hours = linha.hours

                worker.hours = worker.hours == null ? null : parseFloat(worker.hours)

                  worker.Numero = worker.funcionario
            });
        });

        this.loading = false
    },
    methods:{
        save(){
          this.internos_a_mostrar.forEach(element => {
              let data = null
              this.line.linhas_mo_internal.forEach(linhas => {
                  if(element.funcionario == linhas.funcionario){
                      data = element
                      linhas.hours = element.hours
                      linhas.type = 'I'
                  }
              });

              if(data == null){
                  data = {
                      funcionario: element.funcionario,
                      hours: element.hours
                  }

                  this.line.linhas_mo_internal.push(data)
              }
          });

          this.externos_a_mostrar.forEach(element => {
              let data = null
              this.line.linhas_mo_external.forEach(linhas => {
                  if(element.funcionario == linhas.funcionario){
                      data = element
                      linhas.hours = element.hours
                      linhas.type = 'E'
                  }
              });

              if(data == null){
                  data = {
                      funcionario: element.funcionario,
                      hours: element.hours
                  }

                  this.line.linhas_mo_external.push(data)
              }
          });

          return Promise.resolve();
        }
    }
}
</script>